<template>
  <div class="file-field-input-container" :class="{ 'is-multiple': (multiple && files.length > 0) }">
    <div class="file-field-input-content uploaded" v-for="(file, index) in files">
      <div class="file-field-input-content-inner uploaded">
        <div class="dz-details">
          <a class="dz-cancel btn_close" @click.stop.prevent="removeFile(index)">
            <img src="../../../../static/img/icon_close.png" width="23" height="23" alt="close">
          </a>
          <div class="dz-filename">{{file.name}}</div>
          <div class="dz-size">{{fileSize(file.size)}}</div>
          <div class="link" @click="visibleAddUploader = true"
               v-if="!visibleAddUploader && multiple && (index + 1) >= files.length && files.length < limit">データを追加する
          </div>
        </div>
      </div>
    </div>
    <el-upload
            v-if="files.length <= 0 || (visibleAddUploader && multiple)"
            class="file-field-input-content"
            :drag="true"
            name="file"
            :show-file-list="false"
            :on-change="handleChange"
            :auto-upload="false"
            action=""
    >
      <div class="file-field-input-content-inner">
        <div class="dz-details">
          <a class="dz-cancel btn_close" @click.stop.prevent="visibleAddUploader = false"
             v-if="visibleAddUploader && files.length > 0">
            <img src="../../../../static/img/icon_close.png" width="23" height="23" alt="close">
          </a>
          <p class="dz-message">ファイルをドラッグ＆ドロップしてください<br>または<br><a class="link">データを選択する</a></p>
        </div>
      </div>
    </el-upload>
  </div>
</template>

<script lang="js">
import MessageBox from '../../../utils/message-box'
import CommonUtil from '../../../utils/common'

export default {
  name: 'FieldUploadDsCmp',
  props: {
    files: Array,
    maxFileSize: {type: Number, default: (1024 * 1024 * 500)},
    multiple: {type: Boolean, default: false},
    acceptFileExtensions: Array,
    limit: {type: Number, default: 3},
    invalidAcceptFileMessage: {type: String, default: 'このファイルは選択できません'}
  },
  model: {
    prop: 'files',
    event: 'change'
  },
  data () {
    return {
      visibleAddUploader: false
    }
  },
  methods: {
    fileSize (fileSizeByte) {
      let ext = 'B'
      let value = fileSizeByte

      if (CommonUtil.isArray(fileSizeByte)) {
        value = 0
        for (const tmpFileSizeByte of fileSizeByte) {
          value += tmpFileSizeByte
        }
      }

      if (value >= 1024) {
        ext = 'KB'
        value = value / 1024.0
      }
      if (value >= 1024) {
        ext = 'MB'
        value = value / 1024.0
      }
      if (value >= 1024) {
        ext = 'GB'
        value = value / 1024.0
      }

      // decimal one digit
      return `${(Math.round(value * 10) / 10)} ${ext}`
    },
    removeFile (index = -1) {
      if (index >= 0) {
        this.visibleAddUploader = false
        const files = this.files
        const removedFile = files.splice(index, 1)[0]
        this.$emit('change', files)
        this.$emit('removed', files, removedFile)
        this.$forceUpdate()
      }
    },
    handleChange (file, fileList) {
      const fileStatus = file.status
      if (fileStatus === 'ready') {
        if (file.size > this.maxFileSize) {
          MessageBox.alert(this, `ファイルのサイズが上限(${this.fileSize(this.maxFileSize)})を超えています。`).then(() => {
          })
          return false
        } else {
          if (CommonUtil.isNotEmpty(this.acceptFileExtensions)) {
            const fileName = file.name
            const extension = fileName.indexOf('.') >= 0 ? fileName.split('.').slice(-1)[0] : ''
            if (this.acceptFileExtensions.indexOf(extension) < 0) {
              MessageBox.alert(this, this.invalidAcceptFileMessage, {
                dangerouslyUseHTMLString: true
              })
              return false
            }
          }
        }

        const files = this.files
        files.push(file)
        this.visibleAddUploader = false
        this.$emit('change', files)
        this.$emit('added', files, file)
      }
    }
  }
}

</script>

<style scoped>
  .file-field-input-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  /* ------------------------------------------------------- */
  .file-field-input-content {
    width: 100%;
    height: 190px;
    line-height: 1;
    margin: 0;
  }

  .file-field-input-content + .file-field-input-content {
    margin-top: 16px;
  }

  .file-field-input-content.uploaded {
    border: solid 3px #fff;
    border-radius: 6px;
  }

  .file-field-input-container >>> .el-upload {
    width: inherit;
    height: inherit;
  }

  .file-field-input-container >>> .el-upload > .el-upload-dragger {
    width: inherit;
    height: inherit;
    border: dashed 3px #fff;
    background-color: transparent;
  }

  .file-field-input-container >>> .el-upload > .el-upload-dragger:hover {
    border-color: #2456d4;
  }

  .file-field-input-container.disabled >>> .el-upload > .el-upload-dragger {
    cursor: default;
  }

  .file-field-input-container.disabled >>> .el-upload > .el-upload-dragger .file-field-input-content-inner {
    padding: 0;
    border: none;
  }

  .file-field-input-content-inner {
    background: #e2f1f6;
    padding: 30px 20px;
    text-align: center;
    color: #394445;
  }

  .file-field-input-content-inner .dz-details {
    font-size: 0.88rem;
    text-align: center;
    background: url(../../../../static/img/icon_file.png) no-repeat center top;
    background-size: 24px 30px;
    padding: 38px 0 0 0;
    margin: 0;
    line-height: 2;
  }

  .file-field-input-content-inner .dz-details {
    position: relative;
  }

  .file-field-input-content-inner .dz-filename {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .file-field-input-content-inner .dz-cancel.btn_close {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }

  .file-field-input-content-inner .dz-cancel.btn_close:hover {
    opacity: 0.7;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/file-input.vue